const ACCOUNT_LOCAL_STORAGE_KEYS = ["sio72-app", "sio72-settings"] as const;

/** Remove browser state that must never be shared between workbench accounts. */
export function clearAccountScopedClientState(): void {
  if (typeof window === "undefined") {
    return;
  }

  for (const key of ACCOUNT_LOCAL_STORAGE_KEYS) {
    window.localStorage.removeItem(key);
  }

  for (let index = window.sessionStorage.length - 1; index >= 0; index -= 1) {
    const key = window.sessionStorage.key(index);
    if (key?.startsWith("login-refresh-")) {
      window.sessionStorage.removeItem(key);
    }
  }
}
